// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import actions from "../../Redux Store/actions";
// import LoanCard from "./LoanCard";
// import { Grid, Box } from "@mui/material";
// import { over } from "lodash";

// function LoanAssist() {
//   const loggedInUser = useSelector((state) => state.Auth.user);
//   const dispatch = useDispatch();

//   // Hardcoded static loan data (replace with API data when needed)
//   const loanData = [
//     {
//       id: 1,
//       bankCode: "SBI",
//       bankName: "State Bank of India",
//       loanType: "Home Loan",
//       isPopular: true,
//       logoColor: "#1E5BB8",
//       interestRate: 8.4,
//       emiPerLakh: 762,
//       maxTenure: "30 Years",
//       email: "tanaya.apurva@payasystems.com",
//       processingFee: "0.35% + GST",
//       prepayment: "Nil for floating rate",
//       features: ["Balance Transfer", "Top-up Loan", "Doorstep Service"],
//     },
//     {
//       id: 2,
//       bankCode: "HDFC",
//       bankName: "HDFC Bank",
//       loanType: "Home Loan",
//       isPopular: true,
//       logoColor: "#E31E24",
//       interestRate: 8.5,
//       emiPerLakh: 769,
//       maxTenure: "30 Years",
//       email: "aditi.solanke@payasystems.com",
//       processingFee: "0.50% + GST",
//       prepayment: "Nil",
//       features: ["Quick Disbursal", "Flexible EMI", "Online Tracking"],
//     },
//     {
//       id: 3,
//       bankCode: "Axis ",
//       bankName: "Axis Bank",
//       loanType: "Home Loan",
//       isPopular: true,
//       logoColor: "#6d326d",
//       interestRate: 8.5,
//       emiPerLakh: 769,
//       maxTenure: "30 Years",
//       email: "aishwarya.nimbalkar@payasystems.com",
//       processingFee: "0.50% + GST",
//       prepayment: "Nil",
//       features: ["Quick Disbursal", "Flexible EMI", "Online Tracking"],
//     },
//     {
//       id: 4,
//       bankCode: "BOB",
//       bankName: "Bank of Baroda",
//       loanType: "Home Loan",
//       isPopular: true,
//       logoColor: "#c5550a",
//       interestRate: 8.5,
//       emiPerLakh: 769,
//       maxTenure: "30 Years",
//       email: "harshada.sawane@payasystems.com",
//       processingFee: "0.50% + GST",
//       prepayment: "Nil",
//       features: ["Quick Disbursal", "Flexible EMI", "Online Tracking"],
//     },
//     // Add more banks here...
//   ];

//   useEffect(() => {
//     dispatch(actions.activeMenu("loanassist"));
//   }, [dispatch]);

//   return (
//     <div sx={{ overflowX: "hidden" }}>
//       {" "}
//       {/* Container with vertical scrolling */}
//       <h1>Loan Assist</h1>
//       <div>
//         <Box
//           sx={{
//             overflowY: "auto",
//             overflowX: "hidden",
//             padding: "1px",
//             marginTop: "16px",
//           }}
//         >
//           <Grid
//             container
//             spacing={5} // Reduced the spacing between the cards
//             sx={{
//               display: "flex",
//               flexDirection: "row",
//               overflowX: "hidden",
//               mb: 2,
//               justifyContent: "space-between",
//               overflowY: "auto", // This allows the grid to scroll if content exceeds the height
//               height: "600px",
//               paddingBottom: "10px", // Ensures the grid takes full height of the container
//             }}
//           >
//             {loanData.map((bank) => (
//               <Grid item xs={12} sm={6} md={6} key={bank.id}>
//                 <LoanCard bank={bank} />
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       </div>
//     </div>
//   );
// }

// export default LoanAssist;


import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import LoanCard from "./LoanCard";
import { Grid, Box, CardContent, Typography } from "@mui/material";
import { getHomeLoanRates } from "../../Services/loanService";
import { Padding } from "@mui/icons-material";
// import { getLoanRates } from "../../Services/loanService";
 // Import the API service to fetch loan rates

function LoanAssist() {
  const dispatch = useDispatch();
  const [loanData, setLoanData] = useState([]); // State to store loan data
  const [loading, setLoading] = useState(true); // Loading state
  const isMobile = window.innerWidth <= 768; // Check if the device is mobile

  // Fetch loan rates from the API
//   const fetchLoanRates = async () => {
//     try {
//       const rates = await getLoanRates(); // Get data from the API
//       setLoanData(rates); // Set loan data state
//       setLoading(false); // Set loading to false after data is fetched
//     } catch (error) {
//       console.error("Error fetching loan rates:", error);
//       setLoading(false); // Set loading to false even if there is an error
//     }
//   };
// console.log('loan=====>', loanData)
//   useEffect(() => {
//     fetchLoanRates(); // Fetch loan rates when the component mounts
//     dispatch(actions.activeMenu("loanassist")); // Active menu for Redux store
//   }, [dispatch]);

  const fetchLoanRates = async () => {
    try {
      const rates = await getHomeLoanRates(); // Get data from the API
      setLoanData(rates); // Set loan data state
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      console.error("Error fetching loan rates:", error);
      setLoading(false); // Set loading to false even if there is an error
    }
  };
console.log('loan=====>', loanData)
  useEffect(() => {
    fetchLoanRates(); // Fetch loan rates when the component mounts
    dispatch(actions.activeMenu("loanassist")); // Active menu for Redux store
  }, [dispatch]);

  return (
    <div sx={{ overflowX: "hidden"}}>
      <h1 >Loan Assist</h1>

       {/* Note Section */}
      <CardContent sx={{display: "flex",flexDirection: "row",gap: 1, p: 2, backgroundColor: "#EFF8FF",borderRadius: "8px", mb: 2 }}>
        <Typography sx={{color:"red", fontSize: "18px", fontWeight: 500, textAlign: "start" }}>
          *
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            color: "#6B7280",
            textAlign: "start",
          }}
        >
          The interest rates displayed are floating and subject to change based on market conditions. Please verify the rates with the bank before proceeding.
        </Typography>
      </CardContent>
      <div>
        <Box
          sx={{
            overflowY: "auto",
            overflowX: "hidden",
            padding: "1px",
            marginTop: "16px",
          }}
        >
          <Grid
            container
            spacing={5} // Reduced the spacing between the cards
            sx={{
              display: "flex",
              flexDirection: "row",
              overflowX: "hidden",
              paddingRight: "8px", // Add some padding to the right to prevent content from touching the edge
              mb: 2,
              justifyContent: "space-between",
              overflowY: "auto", // This allows the grid to scroll if content exceeds the height
              height: "600px",
              paddingBottom: "10px", // Ensures the grid takes full height of the container
            }}
          >
            {loading ? (
              <p>Loading loan rates...</p> // Show loading message while fetching data
            ) : (
              loanData.map((loanData) => (
                <Grid item xs={12} sm={6} md={6} key={loanData.id}>
                  <LoanCard loanData={loanData} /> {/* Render LoanCard component for each bank */}
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </div>
    </div>
  );
}

export default LoanAssist;

